import { ArrowDownRight, ArrowUpRight } from 'lucide-react';
import { formatPercentRatio } from '../../shared/format';

/** Up/down percentage pill versus the previous period. */
export function Delta({ ratio }: { ratio?: number | null }) {
  if (ratio == null) return null;
  const up = ratio >= 0;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ${
        up ? 'bg-brand-green-light text-brand-green' : 'bg-brand-error-light text-brand-error'
      }`}
    >
      {up ? <ArrowUpRight size={12} /> : <ArrowDownRight size={12} />}
      {formatPercentRatio(ratio)}
    </span>
  );
}
